var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("lifetime-plans-section"),
      _c("payment-guarantee-section", {
        attrs: {
          title: `${_vm.$t(
            "pages.pricing.paymentGuarantee.daysMoneyBackGuaranteeNoQuestionsAsked",
            { days: "30" }
          )}`,
          description: `${_vm.$t(
            "pages.pricing.paymentGuarantee.notFullySatisfiedWithIdeaBuddy",
            { days: "30", email: "support@ideabuddy.com" }
          )}`,
          "money-back-image": require("@/assets/img/pricing/payment-guarantee/30-days-badge-money-back.svg"),
        },
      }),
      _c("features-section"),
      _c("ai-assistance-section"),
      _c("benefits-section"),
      _c("idea-is-safe-section"),
      _c("capterra-reviews-section"),
      _c("lifetime-faq-section"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }